module.exports = __webpack_public_path__ + "static/dashboard_bg@3x-584b0f15adfe9eb057015f9dabb4b1fa.png";